import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { productServiceAdminBrandsClient } from '../api-client/product-service-client';
import { EntriesState, initialEntriesState, Loading } from '../utils/store';
import { RootState } from './index';
import { resolveAxiosErrorResponse } from '../utils/errors';

// Custom selectId function to handle string entities
const adminBrandsAdapter = createEntityAdapter<string>({
  selectId: brand => brand,
});

type BrandsState = EntriesState<string[]>;

export const initialAdminBrandsState: BrandsState = initialEntriesState;

export const fetchAdminBrands = createAsyncThunk('adminBrands/fetchAdminBrandsStatus', async (_, { rejectWithValue }) => {
  try {
    const response = await productServiceAdminBrandsClient.getAdminBrands();
    return response.data.brands;
  } catch (error) {
    return rejectWithValue(resolveAxiosErrorResponse(error)?.statusText);
  }
});

const adminBrands = createSlice({
  name: 'adminBrands',
  initialState: adminBrandsAdapter.getInitialState(initialAdminBrandsState),
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchAdminBrands.pending, state => {
      state.loading = Loading.PENDING;
    });
    builder.addCase(fetchAdminBrands.fulfilled, (state, action) => {
      if (action.payload) {
        adminBrandsAdapter.setAll(state, action.payload);
        state.loading = Loading.SUCCEEDED;
      }
    });
    builder.addCase(fetchAdminBrands.rejected, state => {
      state.loading = Loading.FAILED;
    });
  },
});

export const { selectAll: selectAllBrands } = adminBrandsAdapter.getSelectors((state: RootState) => state.adminBrands);

export const selectAdminBrandsLoading = (state: RootState) => state.adminBrands.loading;

export default adminBrands.reducer;
